<app-header *ngIf="currentUser"></app-header>
<div class="container page">
    <div class="">     
             <div class="landScape">
            <div class="mainDiv">
                <div class="content">
                    <div id="column1" class="column"  >   
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
        <app-footer ></app-footer>
    </div>
</div>
<app-spinner></app-spinner>